export default __webpack_public_path__ + "static/media/understanding_the_indicators_2.3785f758.png";